import React from 'react';
import styled from 'styled-components';
import { translate } from 'base/shared/Localization';
import { getDeviceOsFromStore } from 'datamodel/Device/selectors';
import { useSelector } from 'react-redux';
import { BADI_COLORS } from 'app/badi-components';

import { Spacer, Text, Flex } from '@badi/badi-components';
import Image from 'components/Image/Image';
import Support from 'components/Icons/Support';

const TextWithLink = styled(Text)`
  > a {
    color: ${BADI_COLORS.BRAND.SECONDARY.DEFAULT};
    text-decoration: underline;
    font-weight: 700;
    &:hover {
      color: ${BADI_COLORS.BRAND.SECONDARY.HOVER};
    }
  }
`;

const YellowBlock = styled.div`
  background-color: #ffd685;
  padding: 14px;
  border-radius: 16px;
  cursor: pointer;
  &:hover {
    background-color: #ffc551;
    text-decoration: underline;
  }
`;

const TypeformCta = ({ url = '' }) => {
  const os = useSelector(getDeviceOsFromStore);
  const isIOS = os === 'iOS';
  const isAndroid = os === 'Android';

  const handleClick = () => {
    if (isAndroid || isIOS) {
      const originalUrl = window.location.href;
      window.location.href = mobileUrl;

      setTimeout(() => {
        window.location.href = originalUrl;
      }, 3000);
    } else {
      window.open(url, '_blank').focus();
    }
  };

  return (
    <YellowBlock onClick={handleClick}>
      <Flex justifyContent="justifyBetween" alignItems="center">
        <Spacer right={1}>
          <Support width={'36px'} height={'36px'} color={BADI_COLORS.BRAND.PRIMARY.DEFAULT} />
        </Spacer>
        <Spacer>
          <Text body={2}>{translate('booking.preview.typeform_title')}</Text>
          <Text body={3}> {translate('booking.preview.typeform_cta')}</Text>
        </Spacer>
      </Flex>
    </YellowBlock>
  );
};

export default TypeformCta;
